export const isFilled = (el: HTMLModElement) => el.dataset.adStatus === 'filled';

export const getBannerHeight = (el?: HTMLModElement) => (el && isFilled(el) ? el.clientHeight : 0);
